var refs = 0;
var dispose;
var content = require("!!../../../../css-loader/index.js?sourceMap!../../../../sass-loader/index.js?sourceMap&includePaths[]=/home/circleci/project/bower_components&includePaths[]=/home/circleci/project/node_modules!../../../../postcss-loader/index.js!./ProgressBar.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
exports.use = exports.ref = function() {
	if(!(refs++)) {
		exports.locals = content.locals;
		dispose = require("!../../../../style-loader/addStyles.js")(content, {});
	}
	return exports;
};
exports.unuse = exports.unref = function() {
	if(!(--refs)) {
		dispose();
		dispose = null;
	}
};
if(module.hot) {
	var lastRefs = module.hot.data && module.hot.data.refs || 0;
	if(lastRefs) {
		exports.ref();
		if(!content.locals) {
			refs = lastRefs;
		}
	}
	if(!content.locals) {
		module.hot.accept();
	}
	module.hot.dispose(function(data) {
		data.refs = content.locals ? 0 : refs;
		if(dispose) {
			dispose();
		}
	});
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/table/ProgressBar.scss
 ** module id = 1712
 ** module chunks = 0
 **/